import React from 'react';
import { Container, Label, ButtonsContainer } from './styled';
import { InlineRadioGroupProps } from './types';

export const InlineRadioGroup: React.FC<InlineRadioGroupProps> = ({ children, label }) => (
  <Container>
    <Label>{label}</Label>
    <ButtonsContainer>
      <>{children}</>
    </ButtonsContainer>
  </Container>
);
